import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

import { NotificationCounterStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(): Observable<NotificationCounterStore> {
    return this.httpApi.get('tracking/notifications/counters');
  }
}
